import { render, staticRenderFns } from "./assuntoContrato.vue?vue&type=template&id=672ce0d3"
import script from "./assuntoContrato.vue?vue&type=script&lang=js"
export * from "./assuntoContrato.vue?vue&type=script&lang=js"
import style0 from "./assuntoContrato.vue?vue&type=style&index=0&id=672ce0d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports